//
//
//
//
//
//
//

import FlowSteps from "@/components/StockOrder/comFlowSteps/index.vue";
import PowerScanner from "@/components/StockOrder/comPowerScanner/index.vue";
import FooterButtonList from "@/components/StockOrder/comFooterButtonList/index.vue";
// import shopStockInBuyOrderManager from "@/Manager/04.DumexSms/ShopStockInBuyOrderManager";

var tmpProductSnList = [];
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    "flow-steps": FlowSteps,
    "power-scanner": PowerScanner,
    "footer-button-list": FooterButtonList
  },

  data() {
    //这里存放数据
    return {
      endUrl: "/DumexSms/ShopStockInBuyOrder/End",
      flowStepsConfig: {
        bg: "#fff",
        padding: "15px 40px",
        size: "30px",
        numberSize: "18px",
        textSize: "",
        textTop: "30px",
        lineWidth: "3px",
        list: [
          { number: 1, text: "创建入库单", isDone: true },
          { number: 2, text: "入库扫码", isDone: true },
          { number: 3, text: "入库结束", isActive: false, isDone: false }
        ]
      },

      powerScannerConfig: {
        StockOrderType: 0
      },

      isLoading: false,

      buttonListConfig: {
        btnL: {
          text: "返回",
          action: () =>
            this.$router.go(-1)
        },
        btnR: {
          text: "提交",
          action: () => {
            var endUrl = this.endUrl;
            this.$refs.comPowerScanner.submitOrder(endUrl);
          }
        },
        btnScanCode: {
          action: () => {
            this.$refs.comPowerScanner.openScan();
            return;
          }
        },
        desc: "扫一扫极速入库"
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    this.$refs.comPowerScanner.refreshUI();
  },
  //方法集合
  methods: {
    GetScanCode() {},
    //提交
    Submission() {
      // this.$router.push({ path: url });
      // shopStockInBuyOrderManager.asyncShopStockInOrderSubmit().then(res => {
      //   console.log("提交结果", res);
      //   wx.navigateTo({
      //     url:
      //       "/pages/02_Mms/stockCheckScan/main?type=Warehousing" +
      //       "&number=" +
      //       res.data.OrderNo +
      //       "&time=" +
      //       "2019-09-02 11:08:11" // 页面 A
      //   });
      // });
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  onUnload() {
    console.log("销毁");
    //clearInterval(this.timer);
    //this.powerScanner = null;
  },
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
